var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTomtom = function SvgTomtom(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 58,
    viewBox: "0 0 61 58",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.60001 27.6C1.60001 42.2 13.6 54.2 28.2 54.2C42.8 54.2 54.8 42.2 54.8 27.6C54.8 13 42.8 1 28.2 1C13.6 1.1 1.60001 13 1.60001 27.6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2 53.9C42.7251 53.9 54.5 42.1251 54.5 27.6001C54.5 13.075 42.7251 1.30005 28.2 1.30005C13.6749 1.30005 1.89999 13.075 1.89999 27.6001C1.89999 42.1251 13.6749 53.9 28.2 53.9Z",
    fill: "url(#paint0_linear_6_160)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2 53.9C42.7251 53.9 54.5 42.1251 54.5 27.6001C54.5 13.075 42.7251 1.30005 28.2 1.30005C13.6749 1.30005 1.89999 13.075 1.89999 27.6001C1.89999 42.1251 13.6749 53.9 28.2 53.9Z",
    fill: "url(#paint1_radial_6_160)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2 53.9C42.7251 53.9 54.5 42.1251 54.5 27.6001C54.5 13.075 42.7251 1.30005 28.2 1.30005C13.6749 1.30005 1.89999 13.075 1.89999 27.6001C1.89999 42.1251 13.6749 53.9 28.2 53.9Z",
    fill: "url(#paint2_radial_6_160)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.60001 27.6C1.60001 42.2 13.6 54.2 28.2 54.2C42.8 54.2 54.8 42.2 54.8 27.6C54.8 13 42.8 1 28.2 1C13.6 1.1 1.60001 13 1.60001 27.6ZM2.10001 27.6C2.10001 13.2 13.8 1.5 28.2 1.5C42.6 1.5 54.3 13.2 54.3 27.6C54.3 42 42.6 53.7 28.2 53.7C13.8 53.7 2.10001 42 2.10001 27.6Z",
    fill: "#BCBDBE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1 53.2C25.6 52.4 30.5 46.9 35.9 42.2C36.4 41.8 36.7 41.4 36.7 41.3C36.7 42.3 36.3 43.3 35.4 44.3C30.7 48.8 26.2 53.1 22.1 53.6C21.7 53.4 21.5 53.3 21.1 53.2Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2 33.0001C51.4 36.7001 45.8 37.1001 37.4 37.0001C34.5 36.9001 32 36.7001 29.7 36.7001C27.5 36.5001 26.8 35.8001 26.2 35.3001C26.8 36.0001 28.5 36.3001 29.5 36.4001C31.9 36.6001 34.3 36.6001 37.2 36.7001C43.8 36.9001 51.4 36.4001 54.4 32.3001L54.5 32.1001C54.3 32.5001 54.2 33.0001 54.2 33.0001Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3 18.2999C38.3 17.8999 38 17.4999 37.5 17.1999C33.5 14.0999 29.3 11.4999 25.5 8.8999C25.1 8.5999 24.8 8.2999 24.7 7.8999L24.9 8.69991C25 8.99991 25.2 9.39991 25.7 9.69991C29.3 12.1999 33.3 14.5999 37.1 17.5999C37.5 17.8999 37.9 18.2999 37.9 18.6999C37.9 18.8999 37.8 18.9999 37.7 19.0999L38 18.9999C38.2 18.7999 38.3 18.5999 38.3 18.2999Z",
    fill: "url(#paint3_linear_6_160)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3 12.0999C40.3 10.8999 34.7 5.99994 33.6 4.99994C33.3 4.69994 33.2 4.39995 33.3 4.19995L33 5.19995C32.9 5.49995 33.1 5.89994 33.3 5.99994C34.4 6.99994 39.7 11.6 40.7 12.7C41.2 13.2 41.5 13.6999 41.4 13.9999C41.6 13.9999 41.7 13.8999 41.7 13.8999C42.3 13.5999 42.1 12.9999 41.3 12.0999Z",
    fill: "url(#paint4_linear_6_160)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6 11.8999C48.1 11.5999 48 11.0999 47.8 10.6999C47.3 9.89991 45.5 7.89989 44 6.49989C43.3 5.79989 42.9 5.39989 42.9 4.99989V4.8999L42.2 5.8999L42.1 6.0999C42.1 6.4999 42.4 6.89989 43.1 7.49989C44.5 8.79989 46.2 10.6999 46.7 11.4999C46.8 11.6999 46.8 11.7999 46.8 11.9999L46.9 12.0999C47.1 11.9999 47.3 12.0999 47.6 11.8999Z",
    fill: "url(#paint5_linear_6_160)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8 39.5999V39.7999C22.6 41.8999 23.1 43.2999 24.7 43.5999C27.1 44.0999 30.2 41.1999 31.9 39.6999L32.1 39.5999C33.7 38.1999 35.2 38.7999 35.7 39.2999C36 39.5999 36.1 39.6999 36.5 40.0999L36.8 40.3999L36.5 39.6999C36.4 39.3999 36.3 39.2999 36.2 39.0999C35.9 38.6999 35.8 38.5999 35.5 38.2999C35 37.8999 33.6 37.2999 32 38.5999L31.9 38.6999C30.3 40.0999 27.4 42.7999 25.1 42.2999C23.6 41.9999 22.9 40.5999 23.1 38.5999C22.8 38.9999 22.8 39.2999 22.8 39.5999Z",
    fill: "url(#paint6_linear_6_160)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.70001 28.8999C2.00001 28.9999 2.10001 29.1999 2.20001 29.4999V29.6999C2.80001 31.5999 3.40001 33.6999 4.10001 35.3999L4.20001 35.4999C4.40001 35.7999 4.80001 36.7999 5.20001 36.7999C5.40001 36.8999 5.49999 36.8999 5.79999 36.6999C5.99999 36.4999 6.10001 36.2999 6.10001 35.8999C5.80001 35.5999 5.39999 34.9999 5.29999 34.6999V34.5999C4.49999 32.8999 4 31.0999 3.5 29.0999V28.8999C3.4 28.5999 3.3 28.3999 3 28.3999H2.70001L1.39999 28.6999L1.70001 28.8999Z",
    fill: "url(#paint7_linear_6_160)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22.0001C8.2 23.5001 8.30001 24.6001 8.70001 26.4001L8.89999 27.4001C9.19999 29.1001 9.40001 30.8001 9.70001 32.4001L9.79999 32.8001C9.99999 33.4001 10.1 34.1001 10.8 34.1001C11.2 34.1001 11.5 33.9001 11.6 33.6001C10.9 33.6001 10.8 33.0001 10.6 32.4001L10.5 32.0001C10.2 30.4001 9.90001 28.8001 9.70001 27.3001L9.5 26.4001C9.2 24.8001 9.09999 23.7001 8.89999 22.3001C8.79999 21.6001 8.59999 21.4001 8.29999 21.3001H8.20001H8.10001L7.20001 21.1001H7.39999C7.59999 21.1001 7.9 21.4001 8 22.0001Z",
    fill: "url(#paint8_linear_6_160)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 18.2L16.5 20.9999V22.5999C16.3 25.4999 16.3 28.1999 16.5 30.5999L16.6 32.2999V32.4999C16.6 33.1999 16.7 34 17.4 34.3C18.1 34.4 18.3 34.2 18.6 33.7C18.4 33.8 18.2 33.8 17.9 33.8C17.2 33.6 17.2 32.7999 17.1 32.0999V31.8999L17 30.3999C16.9 27.9999 16.9 25.5999 17 22.7999L17.1 21.2L17.2 18.4999C17.3 17.6999 17.1 17.2999 16.8 17.0999L16.7 16.9999L16.2 16.7C16.6 16.9 16.7 17.2 16.7 18.2Z",
    fill: "url(#paint9_linear_6_160)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1 31.8C26.7 31 27.6 30.8001 28.7 30.9001C29.6 30.9001 30.3 31 30.6 31C33.1 31.2 36.1 31.6001 37.8 30.4001C38.8 29.7001 38.9 28.8001 38.9 28.6001C38.9 28.2001 38.9 28.0001 38.8 27.7001C38.6 27.2001 38.4 26.8 38 26.3C38.4 26.9 38.7 27.4001 38.6 28.2001C38.6 28.8001 38.3 29.5001 37.4 30.1001C35.7 31.2001 32.9 30.9001 30.5 30.7001C30.2 30.7001 29.7 30.6001 28.7 30.6001C27.7 30.6001 26.8 30.7 26.3 31.5C26.1 31.7 26 31.9001 26 32.2001L25.9 32.5C25.9 32.2 26 32 26.1 31.8Z",
    fill: "url(#paint10_linear_6_160)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3 18.2999C38.3 17.8999 38 17.4999 37.5 17.1999C33.5 14.0999 29.3 11.4999 25.5 8.8999C25.1 8.5999 24.8 8.2999 24.7 7.8999L24.9 8.69991C25 8.99991 25.2 9.39991 25.7 9.69991C29.3 12.1999 33.3 14.5999 37.1 17.5999C37.5 17.8999 37.9 18.2999 37.9 18.6999C37.9 18.8999 37.8 18.9999 37.7 19.0999L38 18.9999C38.2 18.7999 38.3 18.5999 38.3 18.2999Z",
    fill: "url(#paint11_linear_6_160)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3 12.0999C40.3 10.8999 34.7 5.99994 33.6 4.99994C33.3 4.69994 33.2 4.39995 33.3 4.19995L33 5.19995C32.9 5.49995 33.1 5.89994 33.3 5.99994C34.4 6.99994 39.7 11.6 40.7 12.7C41.2 13.2 41.5 13.6999 41.4 13.9999C41.6 13.9999 41.7 13.8999 41.7 13.8999C42.3 13.5999 42.1 12.9999 41.3 12.0999Z",
    fill: "url(#paint12_linear_6_160)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6 11.8999C48.1 11.5999 48 11.0999 47.8 10.6999C47.3 9.89991 45.5 7.89989 44 6.49989C43.3 5.79989 42.9 5.39989 42.9 4.99989V4.8999L42.2 5.8999L42.1 6.0999C42.1 6.4999 42.4 6.89989 43.1 7.49989C44.5 8.79989 46.2 10.6999 46.7 11.4999C46.8 11.6999 46.8 11.7999 46.8 11.9999L46.9 12.0999C47.2 11.9999 47.3 12.0999 47.6 11.8999Z",
    fill: "url(#paint13_linear_6_160)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8 39.5999V39.7999C22.6 41.8999 23.1 43.2999 24.7 43.5999C27.1 44.0999 30.2 41.1999 31.9 39.6999L32.1 39.5999C33.7 38.1999 35.2 38.7999 35.7 39.2999C36 39.5999 36.1 39.6999 36.5 40.0999L36.8 40.3999L36.5 39.6999C36.4 39.3999 36.3 39.2999 36.2 39.0999C35.9 38.6999 35.8 38.5999 35.5 38.2999C35 37.8999 33.6 37.2999 32 38.5999L31.9 38.6999C30.3 40.0999 27.4 42.7999 25.1 42.2999C23.6 41.9999 22.9 40.5999 23.1 38.5999C22.8 38.9999 22.8 39.2999 22.8 39.5999Z",
    fill: "url(#paint14_linear_6_160)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1.70001 28.8999C2.00001 28.9999 2.10001 29.1999 2.20001 29.4999V29.6999C2.80001 31.5999 3.40001 33.6999 4.10001 35.3999L4.20001 35.4999C4.40001 35.7999 4.80001 36.7999 5.20001 36.7999C5.40001 36.8999 5.49999 36.8999 5.79999 36.6999C5.99999 36.4999 6.10001 36.2999 6.10001 35.8999C5.80001 35.5999 5.39999 34.9999 5.29999 34.6999V34.5999C4.49999 32.8999 4 31.0999 3.5 29.0999V28.8999C3.4 28.5999 3.3 28.3999 3 28.3999H2.70001L1.39999 28.6999L1.70001 28.8999Z",
    fill: "url(#paint15_linear_6_160)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22.0001C8.2 23.5001 8.30001 24.6001 8.70001 26.4001L8.89999 27.4001C9.19999 29.1001 9.40001 30.8001 9.70001 32.4001L9.79999 32.8001C9.99999 33.4001 10.1 34.1001 10.8 34.1001C11.2 34.1001 11.5 33.9001 11.6 33.6001C10.9 33.6001 10.8 33.0001 10.6 32.4001L10.5 32.0001C10.2 30.4001 9.90001 28.8001 9.70001 27.3001L9.5 26.4001C9.2 24.8001 9.09999 23.7001 8.89999 22.3001C8.79999 21.6001 8.59999 21.4001 8.29999 21.3001H8.20001H8.10001L7.20001 21.1001H7.39999C7.59999 21.1001 7.9 21.4001 8 22.0001Z",
    fill: "url(#paint16_linear_6_160)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 18.2L16.5 20.9999V22.5999C16.3 25.4999 16.3 28.1999 16.5 30.5999L16.6 32.2999V32.4999C16.6 33.1999 16.7 34 17.4 34.3C18.1 34.4 18.3 34.2 18.6 33.7C18.4 33.8 18.2 33.8 17.9 33.8C17.2 33.6 17.2 32.7999 17.1 32.0999V31.8999L17 30.3999C16.9 27.9999 16.9 25.5999 17 22.7999L17.1 21.2L17.2 18.4999C17.3 17.6999 17.1 17.2999 16.8 17.0999L16.7 16.9999L16.2 16.7C16.6 16.9 16.7 17.2 16.7 18.2Z",
    fill: "url(#paint17_linear_6_160)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1 31.8C26.7 31 27.6 30.8001 28.7 30.9001C29.6 30.9001 30.3 31 30.6 31C33.1 31.2 36.1 31.6001 37.8 30.4001C38.8 29.7001 38.9 28.8001 38.9 28.6001C38.9 28.2001 38.9 28.0001 38.8 27.7001C38.6 27.2001 38.4 26.8 38 26.3C38.4 26.9 38.7 27.4001 38.6 28.2001C38.6 28.8001 38.3 29.5001 37.4 30.1001C35.7 31.2001 32.9 30.9001 30.5 30.7001C30.2 30.7001 29.7 30.6001 28.7 30.6001C27.7 30.6001 26.8 30.7 26.3 31.5C26.1 31.7 26 31.9001 26 32.2001L25.9 32.5C25.9 32.2 26 32 26.1 31.8Z",
    fill: "url(#paint18_linear_6_160)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3 40.3001C36 39.9001 35.7 39.6 35.4 39.4C34.7 38.8 33.4 38.6001 32 39.7001L31.9 39.8001C30 41.5001 27 44.3001 24.6 43.8001C22.7 43.4001 22.6 41.7 22.7 40.1C22.7 39.7 22.8 39.3001 22.9 38.8001C23 38.5001 23 38.2 23.1 37.9C23.4 36.7 25.3 28.1 26.3 23.8C26.5 23.1 26.6 22.4 26.5 21.8C26.3 20.9 25.7 20.5 24.6 20.3C23.4 20 21.7 20.6 21.3 21.9C20.8 23.5 20.3 25.7 18.9 32.3C18.8 32.6 18.7 33 18.6 33.3V33.2001C18.3 33.9001 18.2 34.6 17.2 34.5C16.4 34.2 16.3 33.2 16.3 32.6V32.4L16.2 30.7001C16.1 28.2001 16.1 25.6001 16.2 22.7001L16.3 21L16.5 18.2001C16.5 17.4001 16.4 17.0001 16.1 16.7001C15.8 16.4001 15.1 16.3 14.3 16.4C13.7 16.5 13.1 16.7001 12.7 17.2001C12.3 17.6001 12.2 18.2 12.1 18.8C11.9 20.2 11.8 21.7 11.8 23.1C11.6 26 11.6 28.8 11.8 31.8C11.8 32.1 11.8 32.2 11.8 32.4V32.5C11.8 33.9 11.6 34.4 10.8 34.4C9.99998 34.4 9.69999 33.6 9.49999 33L9.39999 32.6C9.09999 30.9 8.7 29.2 8.6 27.6L8.39999 26.6C8.09999 24.9 7.90001 23.7001 7.70001 22.2001C7.70001 21.9001 7.50001 21.4001 7.20001 21.2001C7.00001 21.1001 6.59999 21 5.99999 21.4H5.89999C4.99999 22 4.6 22.8 4.6 23.9C4.6 25.2 4.79999 26.8 4.89999 28C5.19999 31 5.60001 33.0001 6.20001 35.3001L6.29998 35.6C6.49998 36.3 6.4 36.8 6.1 37C5.9 37.2 5.69999 37.2 5.39999 37.1C4.89999 36.9 4.40001 36 4.20001 35.6L4.1 35.5C3.3 33.7 2.80001 31.7001 2.20001 29.7001V29.5C2.20001 29.5 2.09998 29.1 1.79998 29.1C1.49998 29 1.20001 29.1001 0.700006 29.7001C6.28829e-06 30.5001 0.499982 32.6001 0.799982 33.7001C1.99998 39.7001 6.79999 48.9 15.5 52.5C22.3 55.2 26.5 51.7001 35 44.3001C35.7 43.7001 36.5 42.7001 36.7 41.8001C36.7 41.2001 36.7 40.8001 36.3 40.3001Z",
    fill: "#FF1400"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8 18.2001C52.2 10.5001 47.7 6.90009 47 6.30009C46.7 6.10009 45.3 5.0001 44.5 4.7001C44.2 4.6001 44.1 4.60009 43.8 4.60009H43.7H43.6C43.4 4.60009 43.3 4.6001 43.2 4.7001L43.1 5.00008C43.1 5.30008 43.5 5.80009 44.1 6.30009C45.4 7.50009 47.1 9.50009 47.8 10.3001C48.2 10.8001 48.4 11.5001 47.8 11.9001C47.6 12.0001 47.4 12.1001 47 11.9001C46.8 11.8001 46.6 11.6001 46.2 11.3001C44.3 9.40009 40 5.70008 37.4 4.00008C36.2 3.20008 35.2 3.10009 34.2 3.30009L34 3.40009L33.9 3.50008L33.7 3.60009L33.6 3.7001C33.5 3.8001 33.4 3.90008 33.4 4.00008C33.3 4.20008 33.3 4.60009 33.7 4.80009C34.9 5.80009 40.5 10.9001 41.5 12.0001C42.4 13.0001 42.4 13.6001 42.1 13.9001C41.6 14.4001 40.8 13.9001 40.6 13.8001H40.7C40.5 13.7001 40.3 13.5001 40 13.3001C37.2 11.0001 31.1 7.10009 29.6 6.30009C28 5.50009 27.4 5.30008 26.1 6.00008L25.9 6.10009C25.3 6.40009 25.1 6.9001 25.1 7.2001C25 7.5001 25.2 8.00008 25.9 8.50008C31.9 12.5001 33.2 13.2001 37.9 16.8001C38.2 17.1001 39.1 17.9001 38.3 18.7001C38.1 18.9001 37.9 19.0001 37.5 18.9001H37.3H37.5H37.6C37.2 18.8001 36.7 18.6001 36.2 18.2001C33.6 16.6001 29 14.2001 26.6 13.4001C24.9 12.7001 23.9 13.4001 23.3 14.2001C22.8 14.9001 22.7 15.6001 22.8 16.2001C23 16.9001 23.6 17.2001 24 17.5001C27.4 19.4001 30 20.6001 33.3 22.6001C34.3 23.3001 34.6 23.4001 35.6 24.0001C36.8 24.8001 38.5 25.9001 39.1 27.4001C39.2 27.7001 39.3 28.1001 39.3 28.4001C39.3 29.1001 39.1 29.7001 38.2 30.3001C36.6 31.4001 33.7 31.1001 31.1 30.9001C30.6 30.9001 29.7 30.8001 29.1 30.8001C27.8 30.8001 27.1 31.1001 26.7 31.7001C26.4 32.3001 26.3 33.2001 26.3 33.7001C26.3 33.8001 26.3 34.0001 26.4 34.2001C26.4 34.5001 26.6 34.7001 26.6 34.8001V34.9001C27.2 35.7001 28.4 35.9001 29.7 36.1001C32.1 36.3001 34.6 36.3001 37.4 36.4001C44.1 36.6001 51.8 36.1001 54.7 32.0001C56.5 29.2001 56.3 22.6001 54.8 18.2001Z",
    fill: "#FF1400"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 55.9001C17.8 58.8001 11.4 57.6001 6.2 53.0001C1 48.4001 -1.10001 42.2001 1.49999 39.3001C4.09999 36.4001 10.5 37.6001 15.7 42.2001C20.9 46.7001 23 52.8001 20.4 55.9001Z",
    fill: "url(#paint19_radial_6_160)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3 32.6999C54 33.6999 49.9 29.7999 48.1 23.8999C46.3 18.0999 47.6 12.5999 51 11.5999C54.3 10.5999 58.4 14.4999 60.2 20.3999C61.9 26.1999 60.6 31.6999 57.3 32.6999Z",
    fill: "url(#paint20_radial_6_160)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9 3.3999L33.7 3.49989L33.9 3.3999Z",
    fill: "#FF6659"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7 40.1V39.8V39.6V39.5C22.7 39.2 22.8 39.1 22.8 38.8C22.8 39.2 22.7 39.6 22.7 40.1Z",
    fill: "#FF6659"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 6.49994L25.8 6.19995L25.5 6.49994Z",
    fill: "#FF6659"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7 41.1001V40.8001C36.6 40.5001 36.4 40.2001 36.3 40.0001C36 39.6001 35.9 39.5001 35.5 39.2001C35 38.8001 33.5 38.2001 31.9 39.5001L31.7 39.6001C30 41.1001 26.9 44.0001 24.5 43.5001C22.9 43.2001 22.4 41.8001 22.6 39.7001V40.0001C22.5 41.6001 22.7 43.3001 24.5 43.7001C26.9 44.3001 30 41.4001 31.8 39.7001L31.9 39.6001C33.2 38.5001 34.6 38.8001 35.3 39.3001C35.6 39.6001 35.9 39.8001 36.2 40.2001C36.5 40.7001 36.6 41.0001 36.5 41.5001V41.7001L36.6 41.4V41.1001V41.0001L36.7 41.1001Z",
    fill: "#FF6659"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9 38.8C22.9 39.1 22.8 39.3 22.8 39.5C22.8 39.3 22.8 39 22.9 38.8Z",
    fill: "#FF6659"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.6999C16.4 16.9999 16.5 17.4999 16.4 18.1999L16.2 20.9999L16.1 22.6999C15.9 25.5999 15.9 28.2999 16.1 30.6999L16.2 32.3999V32.5999C16.2 33.3999 16.3 34.2999 17.1 34.4999C18 34.6999 18.3 33.9999 18.5 33.1999V33.2999L18.4 33.4999C18.1 34.0999 17.8 34.2999 17.1 34.2999C16.4 34.0999 16.3 33.1999 16.3 32.4999V32.2999L16.2 30.5999C16.1 28.1999 16.1 25.4999 16.2 22.5999L16.3 20.8999L16.5 18.0999C16.6 17.1999 16.4 16.7999 16.1 16.5999C15.9 16.4999 15.3 16.1999 14.4 16.2999L14.1 16.3999C15 16.1999 15.6 16.2999 16 16.6999Z",
    fill: "#FF6659"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1.60001 29.0001C1.90001 29.1001 2 29.4001 2 29.4001V29.6001C2.6 31.6001 3.19999 33.6001 3.89999 35.4001L4 35.5001C4.2 35.9001 4.70001 36.8001 5.20001 37.0001C5.50001 37.1001 5.69999 37.1001 5.89999 36.9001C6.19999 36.6001 6.20001 36.1001 6.10001 35.5001L6 35.2001C6.2 36.0001 6.09999 36.5001 5.79999 36.7001C5.49999 36.9001 5.40001 36.8001 5.20001 36.8001C4.80001 36.6001 4.40001 35.8001 4.20001 35.5001L4.10001 35.4001C3.30001 33.6001 2.80001 31.6001 2.20001 29.7001V29.5001C2.10001 29.3001 2.10001 29.0001 1.60001 29.0001C1.30001 28.8001 0.8 29.3001 0.5 29.7001C1.1 29.0001 1.40001 28.9001 1.60001 29.0001Z",
    fill: "#FF6659"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20001 21.1C7.60001 21.3 7.70001 21.9 7.70001 22.1C7.90001 23.6 7.99999 24.8 8.39999 26.5L8.60001 27.5C8.90001 29.2 9.09999 30.9 9.39999 32.5L9.5 32.9C9.7 33.6 9.89999 34.3001 10.8 34.3001C11.6 34.3001 11.8 33.8 11.8 32.4V32.3V32.5V32.8V33.1C11.7 33.8 11.5 34.2001 10.9 34.2001C10.2 34.2001 9.99999 33.6 9.89999 32.9L9.79999 32.5C9.49999 30.8 9.2 29.1 9 27.5L8.79999 26.5C8.49999 24.8 8.30001 23.6 8.10001 22.1C8.00001 21.4 7.8 21.2 7.5 21C7.2 20.8 6.40001 21.1 6.20001 21.3C6.60001 20.9 6.90001 21 7.20001 21.1Z",
    fill: "#FF6659"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4 33.8C26.4 33.5 26.3 33.4 26.3 33.3C26.3 32.8 26.3 31.9 26.7 31.3C27.1 30.7 27.8 30.4 29.1 30.4C29.7 30.4 30.5 30.5 31.1 30.5C33.6 30.7 36.5 31 38.2 29.9C39.1 29.3 39.3 28.6 39.3 28C39.3 27.7 39.2 27.3 39.1 27C39.2 27.3 39.2 27.5 39.2 27.9C39.2 28.1 39.1 29 38.1 29.7C36.3 30.9 33.5 30.5 30.9 30.3C30.6 30.3 30.1 30.2 29 30.2C27.9 30.2 27 30.3 26.4 31.1C26.1 31.6 26 32.6 26 33.3C26 33.6 26.1 33.9 26.3 34.1L26.4 34.3L26.5 34.4C26.4 34.3 26.4 34.1 26.4 33.8Z",
    fill: "#FF6659"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3 18.7999C39.1 17.9999 38.2 17.2999 37.9 16.8999C33.1 13.2999 31.8 12.5999 25.9 8.59995C25.1 8.09995 25.1 7.59994 25.1 7.29994C25.2 6.89994 25.4 6.49995 25.9 6.19995C25.7 6.29995 25.6 6.39994 25.6 6.49994L25.5 6.59995L25.4 6.69995C25.1 6.99995 24.9 7.29995 24.9 7.59995C24.8 8.09995 25.1 8.49995 25.7 8.89995C29.5 11.4999 33.6 14 37.7 17.2C38.2 17.5 38.5 17.8999 38.5 18.2999C38.5 18.5999 38.3 18.7999 38.2 18.9999L37.9 19.0999H37.8H37.7C37.9 19.0999 38.2 18.9999 38.3 18.7999Z",
    fill: "#FF6659"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1 13.9999C42.4 13.6999 42.4 13.0999 41.5 12.0999C40.5 10.9999 34.9 5.9999 33.7 4.8999C33.4 4.5999 33.4 4.1999 33.4 4.0999L33.6 3.7999L33.7 3.69991L33.9 3.5999L34 3.49989L34.2 3.3999C34 3.3999 33.4 3.69989 33.3 3.99989C33.1 4.29989 33.3 4.79989 33.6 4.99989C34.7 5.99989 40.3 10.9999 41.3 12.0999C42.1 12.8999 42.3 13.5999 41.7 13.9999C41.5 14.1999 41.2 14.2999 40.6 13.7999H40.5C40.8 13.9999 41.6 14.4999 42.1 13.9999Z",
    fill: "#FF6659"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M47 11.9001C47.4 12.1001 47.7 12.0001 47.8 11.9001C48.4 11.6001 48.2 10.9001 47.8 10.3001C47.2 9.50009 45.4 7.40009 44.1 6.30009C43.5 5.70009 43.1 5.20009 43.1 5.00009L43.2 4.7001C43.3 4.6001 43.5 4.6001 43.6 4.6001H43.7H43.8H43.9C43.6 4.6001 43.3 4.6001 43.1 4.7001L42.9 5.00009C42.9 5.40009 43.3 5.80009 44 6.50009C45.4 7.90009 47.2 10.0001 47.8 10.7001C48.1 11.1001 48.1 11.6001 47.6 11.9001C47.4 12.0001 47.3 12.0001 47 11.9001Z",
    fill: "#FF6659"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_160",
    x1: 9.60976,
    y1: 8.97294,
    x2: 46.8633,
    y2: 46.2265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3957,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5266,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6847,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7416,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6_160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.2369 27.6) scale(26.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8483,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8833,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9256,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9663,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_6_160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.2369 27.6) scale(26.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7079,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8161,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9472,
    stopColor: "#EBECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_160",
    x1: 25.9951,
    y1: 14.4744,
    x2: 37.3668,
    y2: 12.4692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAA9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0505618,
    stopColor: "#FF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3708,
    stopColor: "#FF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4694,
    stopColor: "#FF1804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5641,
    stopColor: "#FF230F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6573,
    stopColor: "#FF3623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    stopColor: "#FF503E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8411,
    stopColor: "#FF7261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#FF9B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9607,
    stopColor: "#FFAA9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_160",
    x1: 32.4071,
    y1: 5.07605,
    x2: 42.2983,
    y2: 13.3759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAA9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#FF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    stopColor: "#FF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6_160",
    x1: 41.9441,
    y1: 6.05605,
    x2: 48.1996,
    y2: 11.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAA9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00561798,
    stopColor: "#FFAA9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1236,
    stopColor: "#FF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3708,
    stopColor: "#FF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4694,
    stopColor: "#FF1804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5641,
    stopColor: "#FF230F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6573,
    stopColor: "#FF3623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    stopColor: "#FF503E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8411,
    stopColor: "#FF7261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#FF9B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9607,
    stopColor: "#FFAA9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6_160",
    x1: 23.52,
    y1: 43.1133,
    x2: 34.5746,
    y2: 36.7308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAA9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0449438,
    stopColor: "#FFAA9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4494,
    stopColor: "#FF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7247,
    stopColor: "#FF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#FF4E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6_160",
    x1: 3.82994,
    y1: 36.8288,
    x2: 3.82994,
    y2: 28.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAA9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0337079,
    stopColor: "#FFAA9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4101,
    stopColor: "#FF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8605,
    stopColor: "#FF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8708,
    stopColor: "#FF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6_160",
    x1: 7.78902,
    y1: 33.3446,
    x2: 10.8724,
    y2: 21.8372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAA9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351261,
    stopColor: "#FFA495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0806648,
    stopColor: "#FF9585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1319,
    stopColor: "#FF7B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1874,
    stopColor: "#FF5745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2456,
    stopColor: "#FF2916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2697,
    stopColor: "#FF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8464,
    stopColor: "#FF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8596,
    stopColor: "#FF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6_160",
    x1: 13.375,
    y1: 31.9553,
    x2: 20.7269,
    y2: 19.2213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAA9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0561798,
    stopColor: "#FFAA9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3708,
    stopColor: "#FF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8073,
    stopColor: "#FF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8764,
    stopColor: "#FF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6_160",
    x1: 28.1535,
    y1: 34.7547,
    x2: 37.2648,
    y2: 25.6434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6067,
    stopColor: "#FF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7363,
    stopColor: "#FF6755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8483,
    stopColor: "#FFAA9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6_160",
    x1: 25.9951,
    y1: 14.4744,
    x2: 37.3668,
    y2: 12.4692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0505618,
    stopColor: "#E3E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3708,
    stopColor: "#E3E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5961,
    stopColor: "#E7E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#F2F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9607,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6_160",
    x1: 32.4071,
    y1: 5.07605,
    x2: 42.2983,
    y2: 13.3759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#E3E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    stopColor: "#E3E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6_160",
    x1: 41.9441,
    y1: 6.05605,
    x2: 48.1996,
    y2: 11.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00561798,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1236,
    stopColor: "#E3E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3708,
    stopColor: "#E3E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5961,
    stopColor: "#E7E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#F2F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9607,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6_160",
    x1: 23.52,
    y1: 43.1133,
    x2: 34.5746,
    y2: 36.7308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0505618,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2014,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4048,
    stopColor: "#E8E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4494,
    stopColor: "#E3E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7247,
    stopColor: "#E3E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6_160",
    x1: 3.82994,
    y1: 36.8288,
    x2: 3.82994,
    y2: 28.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0337079,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4101,
    stopColor: "#E3E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8605,
    stopColor: "#E3E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8708,
    stopColor: "#E3E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6_160",
    x1: 7.78902,
    y1: 33.3446,
    x2: 10.8724,
    y2: 21.8372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1008,
    stopColor: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2312,
    stopColor: "#E9EAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2697,
    stopColor: "#E3E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8464,
    stopColor: "#E3E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8596,
    stopColor: "#E3E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6_160",
    x1: 13.375,
    y1: 31.9553,
    x2: 20.7269,
    y2: 19.2213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0561798,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3708,
    stopColor: "#E3E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8073,
    stopColor: "#E3E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8764,
    stopColor: "#E3E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6_160",
    x1: 28.1535,
    y1: 34.7547,
    x2: 37.2648,
    y2: 25.6434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6067,
    stopColor: "#E3E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8483,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_6_160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.9552 47.531) rotate(41.3918) scale(12.6348 7.19289)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBBAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1142,
    stopColor: "#FFB5A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2781,
    stopColor: "#FFA295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4722,
    stopColor: "#FF8576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6894,
    stopColor: "#FF5B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9229,
    stopColor: "#FF2714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_6_160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.1355 22.1809) rotate(73.3337) scale(10.9778 6.24951)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBBAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1142,
    stopColor: "#FFB5A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2781,
    stopColor: "#FFA295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4722,
    stopColor: "#FF8576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6894,
    stopColor: "#FF5B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9229,
    stopColor: "#FF2714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1400"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTomtom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tomtom.579b0385.svg";
export { ForwardRef as ReactComponent };